import { create } from 'zustand';
import { GetPredictorStatsResponse, Predictor } from '../../interfaces/predictors';

export interface PredictorStoreState {
  activePredictor?: Predictor;
  nextPredictor?: Predictor;
  predictorStats?: GetPredictorStatsResponse;
  setActivePredictor: (activePredictor?: Predictor) => void;
  setNextPredictor: (nextPredictor?: Predictor) => void;
  setPredictorStats: (predictorStats: GetPredictorStatsResponse) => void;
}

export const usePredictorStore = create<PredictorStoreState>()((set) => ({
  activePredictor: undefined,
  nextPredictor: undefined,
  predictorStats: undefined,
  setActivePredictor: (activePredictor) => set(() => ({ activePredictor })),
  setNextPredictor: (nextPredictor) => set(() => ({ nextPredictor })),
  setPredictorStats: (predictorStats) => set(() => ({ predictorStats })),
}));
